import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle, WarningCircle, XCircle } from "@phosphor-icons/react";
import { DomainCheckButton } from "@/components/domaincheck/DomainCheckButton";

const AUTO = {
  pass: ["Check passed", "text-emerald-700", CheckCircle],
  warn: ["Needs a look", "text-amber-600", WarningCircle],
  fail: ["Not ready", "text-red-600", XCircle],
};

function ItemLink({ link, testId }) {
  if (!link) return null;
  const cls = "text-[11px] uppercase tracking-widest underline hover:no-underline";
  if (["/privacy", "/terms", "/legal-partners"].includes(link)) {
    return <a href={link} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId}>Open</a>;
  }
  return <Link to={link} className={cls} data-testid={testId}>Open</Link>;
}

export function GoLiveItem({ item, busy, onToggle, onRefresh }) {
  const auto = item.auto && AUTO[item.auto.status];
  const Icon = auto?.[2];
  const id = `golive-item-${item.key}`;
  return (
    <li className="flex gap-3 border-b border-zinc-200 py-3 last:border-b-0" data-testid={id}>
      <input type="checkbox" className="mt-1 h-4 w-4 shrink-0 accent-black" checked={item.done} disabled={busy}
        onChange={(e) => onToggle(item.key, e.target.checked)} aria-label={item.title} data-testid={`${id}-check`} />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <span className={`font-bold ${item.done ? "text-zinc-500 line-through" : ""}`}>{item.title}</span>
          <ItemLink link={item.link} testId={`${id}-link`} />
          {item.key === "domain_pages" && <DomainCheckButton label="Check now" testId="golive-domain-check" onDone={onRefresh} />}
        </div>
        {item.help && <p className="text-[12px] leading-snug text-zinc-600">{item.help}</p>}
        {auto ? (
          <p className={`mt-1 flex items-start gap-1 text-[12px] ${auto[1]}`} data-testid={`${id}-auto`} data-status={item.auto.status}>
            <Icon size={14} weight="bold" className="mt-[2px] shrink-0" />
            <span><b>{auto[0]}:</b> {item.auto.detail}</span>
          </p>
        ) : (
          <p className="mt-1 text-[11px] uppercase tracking-widest text-zinc-400" data-testid={`${id}-manual`}>You check this one</p>
        )}
        {item.done && item.auto?.status === "fail" && (
          <p className="text-[12px] text-red-600" data-testid={`${id}-ticked-failing`}>Ticked, but the system check still fails.</p>
        )}
        {item.done && item.done_by && (
          <p className="text-[11px] text-zinc-400" data-testid={`${id}-done-by`}>
            Ticked by {item.done_by}{item.done_at ? ` · ${new Date(item.done_at).toLocaleDateString()}` : ""}
          </p>
        )}
      </div>
    </li>
  );
}
